/*
* Shopify Pursuit Theme - External URL Parameter Popup Trigger
*
* This script intercepts the theme's entry popup HTML as it loads
* and tricks the theme into opening it if '?discount' is present in the URL.
* It preserves existing user cookies.
*/
/*
 if (window.location.search.includes('discount')) {
 const observer = new MutationObserver((mutations, obs) => {
   const el = document.querySelector('.entry_popup_wrapper .entry-modal');
   if (el) {
     el.setAttribute('data-cookie', 'use_test_popup');
     obs.disconnect();
   }
 });
 observer.observe(document.documentElement, { childList: true, subtree: true });
}
*/


if (window.location.search.includes('discount')) {
  const targetSelector = '.entry_popup_wrapper .entry-modal';
  
  // 1. Define the action to take when the element is found
  const applyAttribute = (el, obs = null) => {
    el.setAttribute('data-cookie', 'use_test_popup');
    if (obs) obs.disconnect(); // Stop observing if we used the observer
  };

  // 2. Immediate Check: See if it already exists right now
  const existingEl = document.querySelector(targetSelector);
  if (existingEl) {
    applyAttribute(existingEl);
  } else {
    // 3. Fallback: Watch for it if it hasn't loaded yet
    const observer = new MutationObserver((mutations, obs) => {
      const dynamicEl = document.querySelector(targetSelector);
      if (dynamicEl) {
        applyAttribute(dynamicEl, obs);
      }
    });
    
    observer.observe(document.documentElement, { 
      childList: true, 
      subtree: true 
    });
  }
}

